/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCheckoutRedeliveryRequestCheckoutRedelivery
 */
export interface CreateCheckoutRedeliveryRequestCheckoutRedelivery {
    /**
     * 
     * @type {string}
     * @memberof CreateCheckoutRedeliveryRequestCheckoutRedelivery
     */
    checkoutParcelId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCheckoutRedeliveryRequestCheckoutRedelivery
     */
    reason: CreateCheckoutRedeliveryRequestCheckoutRedeliveryReasonEnum;
    /**
     * 
     * @type {Date}
     * @memberof CreateCheckoutRedeliveryRequestCheckoutRedelivery
     */
    redeliveryDate: Date;
    /**
     * 
     * @type {string}
     * @memberof CreateCheckoutRedeliveryRequestCheckoutRedelivery
     */
    redeliveryTime?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateCheckoutRedeliveryRequestCheckoutRedelivery
     */
    redeliveryCommission?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateCheckoutRedeliveryRequestCheckoutRedelivery
     */
    note?: string;
}


/**
 * @export
 */
export const CreateCheckoutRedeliveryRequestCheckoutRedeliveryReasonEnum = {
    Pending: 'pending',
    Absent: 'absent',
    AddressUnknown: 'address_unknown',
    OperationMiss: 'operation_miss',
    Other: 'other'
} as const;
export type CreateCheckoutRedeliveryRequestCheckoutRedeliveryReasonEnum = typeof CreateCheckoutRedeliveryRequestCheckoutRedeliveryReasonEnum[keyof typeof CreateCheckoutRedeliveryRequestCheckoutRedeliveryReasonEnum];


/**
 * Check if a given object implements the CreateCheckoutRedeliveryRequestCheckoutRedelivery interface.
 */
export function instanceOfCreateCheckoutRedeliveryRequestCheckoutRedelivery(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "checkoutParcelId" in value;
    isInstance = isInstance && "reason" in value;
    isInstance = isInstance && "redeliveryDate" in value;

    return isInstance;
}

export function CreateCheckoutRedeliveryRequestCheckoutRedeliveryFromJSON(json: any): CreateCheckoutRedeliveryRequestCheckoutRedelivery {
    return CreateCheckoutRedeliveryRequestCheckoutRedeliveryFromJSONTyped(json, false);
}

export function CreateCheckoutRedeliveryRequestCheckoutRedeliveryFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCheckoutRedeliveryRequestCheckoutRedelivery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'checkoutParcelId': json['checkout_parcel_id'],
        'reason': json['reason'],
        'redeliveryDate': (new Date(json['redelivery_date'])),
        'redeliveryTime': !exists(json, 'redelivery_time') ? undefined : json['redelivery_time'],
        'redeliveryCommission': !exists(json, 'redelivery_commission') ? undefined : json['redelivery_commission'],
        'note': !exists(json, 'note') ? undefined : json['note'],
    };
}

export function CreateCheckoutRedeliveryRequestCheckoutRedeliveryToJSON(value?: CreateCheckoutRedeliveryRequestCheckoutRedelivery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'checkout_parcel_id': value.checkoutParcelId,
        'reason': value.reason,
        'redelivery_date': (value.redeliveryDate.toISOString().substr(0,10)),
        'redelivery_time': value.redeliveryTime,
        'redelivery_commission': value.redeliveryCommission,
        'note': value.note,
    };
}

